import { render, staticRenderFns } from "./AdministartionPage.vue?vue&type=template&id=8902cdc2&"
import script from "./AdministartionPage.vue?vue&type=script&lang=js&"
export * from "./AdministartionPage.vue?vue&type=script&lang=js&"
import style0 from "./AdministartionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports